var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.833 15.2109H17.9163V16.2943H7.08301V15.2109H8.16634V11.4193C8.16634 10.27 8.62289 9.1678 9.43555 8.35514C10.2482 7.54248 11.3504 7.08594 12.4997 7.08594C13.6489 7.08594 14.7511 7.54248 15.5638 8.35514C16.3765 9.1678 16.833 10.27 16.833 11.4193V15.2109ZM10.8747 17.3776H14.1247V18.4609H10.8747V17.3776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFilledIcon);
export default __webpack_public_path__ + "static/media/bell-filled-icon.e2a881b78195d87c05be2ef7388d7b00.svg";
export { ForwardRef as ReactComponent };